import { useMutation } from "react-query";

import type {
  BookingIntervalResponse,
  PostBookingIntervalArgs,
} from "api/services/appointment/schemas/booking_interval";
import { useApiClient } from "api/useApiClient";

export const usePostBookingInterval = () => {
  const client = useApiClient();

  return useMutation<BookingIntervalResponse, Error, PostBookingIntervalArgs>({
    mutationFn: args => client.postBookingInterval(args),
  });
};
